import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useGetUserEvents = ({
  useruuid,
  startDate,
  endDate,
  eventTypes,
  open,
  deviceuuid,
  queryOptions,
}) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiQuery(
    ['getUserEvents', useruuid, deviceuuid, startDate, endDate, JSON.stringify(eventTypes)],
    () =>
      new Promise((resolve, reject) => {
        userEventsApi.userDeviceEventsByTypesAndTimeRange(
          useruuid,
          startDate,
          endDate,
          { eventtypes: eventTypes, deviceuuid: [deviceuuid] },
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data['user_events'] || []);
            },
            errorCallback: () => {
              reject([]);
            },
          })
        );
      }),
    {
      enabled:
        !!useruuid &&
        !!startDate &&
        !!endDate &&
        !!open &&
        !!deviceuuid &&
        Array.isArray(eventTypes) &&
        eventTypes.length > 0,
      ...queryOptions,
    }
  );
};

export default useGetUserEvents;
